module.exports = __webpack_public_path__ + "static/media/fb.181fe60c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Person/components/Social/fb.svg
// module id = 109
// module chunks = 0